/*
 * Copyright (c) Nexign, JSC, 1992-2022.
 */
/**
 * The class - style wrapper on item list
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Alexander Golshtein
 * @version 1.24.0
 * @since 1.0.0
 */
import React, { memo } from 'react';

import styled from 'styled-components';

import { colors, fonts, selectItem } from '../../../theme';

export interface ISelectedItemProps extends React.Props<any> {
    selected?: boolean;
    kind?: string;
    disabled?: boolean;
}

const SelectItemStyled = styled.li.attrs({
    tabIndex: 0,
})<ISelectedItemProps>`
    ${fonts.textSmall};
    cursor: pointer;
    padding: 8px 32px 8px 16px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    box-sizing: border-box;
    height: 32px;
    color: ${selectItem.fontColor};
    width: 100%;
    user-select: none;
    &:focus,
    &:hover {
        background-color: ${selectItem.bgColorHover};
        outline: none;
    }
    &.disable {
      color: ${colors.textColorOpacity};
      cursor: auto;
      pointer-events: none;
    }
`;

SelectItemStyled.defaultProps = {
    selected: false,
    kind: 'normal',
};

export default memo(SelectItemStyled);
